import { productTypesInversed } from '@teinor/erp/types/company/product'
import { checkUniqueNumberComplete } from '../../../utils/globals/product/uniqueNumber'
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../baseComponents/TwinIcon'
import Checkbox from '../../../forms/Checkbox'
import { ITCheckboxProps } from '../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'

interface BuySelectedCheckboxProps extends ITCheckboxProps {
}

export const BuySelectedCheckbox: React.FC<BuySelectedCheckboxProps> = ({ onChange,  allRowData, value, extraProps }) => {
    const productType = allRowData['productType']
    const isSerializedOrLot = productType === productTypesInversed['serialized'] || productType === productTypesInversed['lots'];
    if (allRowData.processed) {
        return null
    }
    const showWarningIcon = extraProps?.nextStepNotFinished ? false : !checkUniqueNumberComplete(allRowData)
    if (isSerializedOrLot && showWarningIcon) {
        return <TwinIcon icon={faTriangleExclamation} className='w-18 text-red-BA ' />
    }
    return <Checkbox label={''} checked={value === true as any} onChange={onChange} />
}